import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styles from './styles.css';

export default class Field extends Component {
    static propTypes = {
        label: PropTypes.string,
        helpText: PropTypes.string,
        children: PropTypes.node.isRequired,
        centered: PropTypes.bool,
        horizontal: PropTypes.bool,
        className: PropTypes.string
    };

    render() {
        return (
            <div className={classNames(styles.root, {
                [styles.centered]: this.props.centered,
                [styles.vertical]: !this.props.horizontal,
                [styles.horizontal]: this.props.horizontal,
            })}>
                {this.props.label && <div className={classNames(styles.label, this.props.className)}>{this.props.label}</div>}
                {this.props.children}
                {this.props.helpText && (<div className={styles.helpText}>{this.props.helpText}</div>)}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/forms/field/index.js